import Vue from 'vue';

window.Sentry.attachErrorHandler(Vue, {
    attachProps: true,
    logErrors: true,
    timeout: 2000,
    trackComponents: false,
    hooks: ['activate', 'mount', 'update'],
});
